<template>
  <transition name="slide-fade">
    <v-container fluid>
      <v-layout wrap class="justify-center">
        <v-flex xs12>
          <h3 class="text-center">Currencies Available</h3>
        </v-flex>
        <v-flex xs12 sm11 md9>
          <v-card flat>
            <v-card-title>
              <v-spacer></v-spacer>
              <v-btn small @click="AddCurr = !AddCurr" color="primary" v-if="canCreate">
                <v-icon left>mdi-cash-plus</v-icon>Add
              </v-btn>
            </v-card-title>
            <v-card-text>
              <v-data-table :items="currencies" :headers="headers" :options="options" dense>
                <template v-slot:[`item.actions`]="{ item }">
                  <v-btn small icon @click.stop.prevent="goTo('/currencies/' + item.id + '/edit')" :href="'/currencies/' + item.id + '/edit'" title="Edit currency" color="warning">
                    <v-icon>{{ icons.edit }}</v-icon>
                  </v-btn>
                  <delete-currency :currency="item"></delete-currency>
                </template>
                <template v-slot:[`item.active`]="{ item }">
                  <activate-currency :errors="errors" :currency="item"></activate-currency>
                </template>
                <template v-slot:[`item.default`]="{ item }">
                  <default-currency :errors="errors" :currency="item"></default-currency>
                </template>
              </v-data-table>
            </v-card-text>
            <v-card-actions class="py-0">
              <v-spacer></v-spacer>
              <confirm-password @confirmed="goTo('/currencies/conversion?force=1')">
                <v-btn small>Update Conversion</v-btn>
              </confirm-password>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
      <mk-dialog v-model="AddCurr">
        <template v-slot:title>Add New Currency</template>
        <create-currencies :errors="errors" @saved="AddCurr = false"></create-currencies>
      </mk-dialog>
    </v-container>
  </transition>
</template>

<script>
  import layout from '@/Layouts/MainLayout'
  const MkDialog = async () => await import(/* webpackMode: 'lazy' */ /* webpackChunkName: "main-components" */ '@/Components/components/mk-dialog')
  const ConfirmPassword = async () => await import(/* webpackMode: 'lazy' */ /* webpackChunkName: "main-components" */ '@/Components/components/ConfirmsPassword')
  const CreateCurrencies =  async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "currencies" */ '@/Components/Currencies/create')
  const DeleteCurrency =  async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "currencies" */ '@/Components/Currencies/deleteCurrency')
  const ActivateCurrency =  async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "currencies" */ '@/Components/Currencies/active')
  const DefaultCurrency =  async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "currencies" */ '@/Components/Currencies/default')

  export default {
    name: 'CurrenciesIndex',
    layout,
    props: [
      'currencies',
      'canCreate',
      'errors'
    ],
    components: {
      CreateCurrencies,
      DeleteCurrency,
      ActivateCurrency,
      DefaultCurrency,
      ConfirmPassword,
      MkDialog,
    },
    metaInfo () {
      return {
        title: 'Currencies Available',
        titleTemplate: '%s | ' + this.$title,
      }
    },
    data () {
      return {
        headers: [
          {
            text: 'Name', value: 'name'
          },
          {
            text: '', value: 'symbol',
          },
          {
            text: 'Code', value: 'code',
          },
          {
            text: 'Countries', value: 'countries',
          },
          {
            text: 'Active', value: 'active', align: 'center'
          },
          {
            text: 'Default', value: 'default', align: 'center'
          },
          {
            text: 'Rate', value: 'rate', align: 'right'
          },
          {
            text: '', value: 'actions', sortable: false, align: 'right'
          }
        ],
        AddCurr: false,
        options: {
          sortBy: ['default', 'active'],
          sortDesc: [true, true]
        }
      }
    },
  }
</script>
